var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 31.6667V53M53 74.3333H53.0533M101 53C101 59.3035 99.7585 65.5452 97.3462 71.3688C94.934 77.1924 91.3983 82.4839 86.9411 86.9411C82.4839 91.3983 77.1924 94.934 71.3688 97.3462C65.5452 99.7585 59.3035 101 53 101C46.6966 101 40.4548 99.7585 34.6312 97.3462C28.8076 94.934 23.5161 91.3983 19.0589 86.9411C14.6017 82.4839 11.066 77.1924 8.65378 71.3688C6.24156 65.5452 5 59.3035 5 53C5 40.2696 10.0571 28.0606 19.0589 19.0589C28.0606 10.0571 40.2696 5 53 5C65.7304 5 77.9394 10.0571 86.9411 19.0589C95.9429 28.0606 101 40.2696 101 53Z",
    stroke: "#5C1628",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b66323b4fc3a86dc30a412d5804d4c2d.svg";
export { ForwardRef as ReactComponent };